import { useState } from "react";
import { SelectCarByAttributes } from "./SelectCarByAttributes";
import { SelectCarByVin } from "./SelectCarByVin";
import { Loader } from "lucide-react";
// import { LoadData } from "../../../../widgets/Load/LoadData";
// import { carBrandsLoader } from "../../../../utils/storage/extra/loaders/laximo/carBrandsLoader";

/**
 * Сопутствующие товары
 * @param product - данные о товаре
 * @returns 
 */
export const CarSelection: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="w-full max-w-5xl mb-6 relative">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 border border-orange-200/60 rounded-xl p-4 shadow-sm">
                <div className="mb-3">
                    <h3 className="text-lg font-bold text-orange-700">
                        Сначала добавьте ваш автомобиль — <span className="font-normal text-gray-600">получите точное соответствие для вашего автомобиля</span>
                    </h3>
                </div>
                <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-start">
                    {/* <LoadData reducerName="laximo" resourceName="carBrands" loader={carBrandsLoader}> */}
                        <SelectCarByAttributes />
                    {/* </LoadData> */}
                    <div className="hidden lg:flex w-px bg-orange-200 self-stretch"></div>
                    <SelectCarByVin setIsLoading={setIsLoading} />
                </div>
            </div>
            {isLoading && <div className="absolute top-0 h-full w-full flex items-center justify-center opacity-50">
                <div className="absolute top-0 h-full w-full bg-black bg-opacity-70 rounded-xl"></div>
                <Loader className='w-8 h-8 animate-spin text-orange-500 absolute top-1/2 left-1/2' />
            </div>}
        </div>
    );
};